import script from "./mobile-bottom-nav.vue?vue&type=script&setup=true&lang=js"
export * from "./mobile-bottom-nav.vue?vue&type=script&setup=true&lang=js"

import "./mobile-bottom-nav.vue?vue&type=style&index=0&id=fc1fc7a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fc1fc7a0"]])

export default __exports__